import { render } from "./SingleAnswer.vue?vue&type=template&id=6a8f3cee&ts=true"
import script from "./SingleAnswer.vue?vue&type=script&lang=ts"
export * from "./SingleAnswer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__